var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"spinner",class:[
        _vm.spinnerEffect,
        _vm.spinnerSize ]},[_c('img',{staticClass:"spinner__image",attrs:{"src":_vm.spinnerAsset}}),_c('div',{staticClass:"spinner__text"},[_vm._t("spinner-text",[_vm._v(_vm._s(_vm.spinnerText))])],2)])}
var staticRenderFns = []

export { render, staticRenderFns }